import RestAPI from '../restApi';

export class UIConfigurationApi {
  static saveUIConfiguration(data) {
    const requestUrl = `/api/v2/pro/ui_config/`;
    return RestAPI.postWithFormData(requestUrl, data);
  }

  static getUIConfiguration(componentName, componentKey) {
    return RestAPI.getWithFormData(`/api/v2/pro/ui_config/get`, {
      component_name: componentName,
      component_key: componentKey,
    });
  }
}
